import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IInfoByTokenPayload {
    sharedListId?: string
    token: string
}

export interface IInfoByTokenState {
    status: string
    data: any
    errors: any
}

const initialState: IInfoByTokenState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const infoByToken = createSlice({
    name: 'sharedList/info-by-token',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IInfoByTokenPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const infoByTokenActions = infoByToken.actions
export default infoByToken.reducer
